{
  "en": {
    "messages": {
      "fleetchartScreenshot": {
        "failure": "The fleetchart could not be saved as an image"
      },
      "buyback": {
        "destroy": {
          "failure": "Could not remove the buy-back pledge."
        }
      },
      "hangarShare": {
        "enable": {
          "success": "Share link created.",
          "failure": "Could not create the share link."
        },
        "rotate": {
          "success": "Share link rotated. The old link no longer works.",
          "failure": "Could not rotate the share link.",
          "confirm": "Rotating the link stops the current one from working. Anyone you shared it with will need the new link."
        },
        "disable": {
          "success": "Share link deleted.",
          "failure": "Could not delete the share link.",
          "confirm": "Deleting the link stops it from working for everyone you shared it with."
        },
        "copy": {
          "success": "Share link copied to clipboard.",
          "failure": "Could not copy the share link."
        }
      },
      "loading": "Loading…",
      "copy": {
        "success": "Text Copied!",
        "failure": "Could not copy Text"
      },
      "copyGitRevision": {
        "success": "Git Revision Copied!",
        "failure": "Could not copy Git Revision"
      },
      "copyImageUrl": {
        "success": "Image URL Copied!",
        "failure": "Could not copy Image URL"
      },
      "copyVideoUrl": {
        "success": "Video URL Copied!",
        "failure": "Could not copy Video URL"
      },
      "copyShareUrl": {
        "success": "URL \"%{url}\" Copied!",
        "failure": "Could not copy URL"
      },
      "copyInviteUrl": {
        "success": "Invite URL \"%{url}\" Copied!",
        "failure": "Could not copy Invite URL"
      },
      "copyTwoFactorProvisioningUrl": {
        "success": "Provisioning Url Copied!",
        "failure": "Could not copy Provisioning Url"
      },
      "copyBackupCodes": {
        "success": "Backup Codes Copied!",
        "failure": "Could not copy Backup Codes"
      },
      "signup": {
        "success": "<b>Welcome to FleetYards.net!</b> Your account has been created. <br>You will receive a confirmation email to activate your account.",
        "invalid": "Please resolve the errors before your account can be created.",
        "failure": "We could not create your account. Please try again later."
      },
      "accountConfirm": {
        "success": "Your account was successfully confirmed.<br>You can now login.",
        "failure": "Your account could not be confirmed."
      },
      "requestPasswordChange": {
        "success": "If your email address exists in our database, you will receive a password recovery link at your email address in a few minutes."
      },
      "changePassword": {
        "success": "Your password was changed successfully.",
        "failure": "Your password could not be updated."
      },
      "modelModule": {
        "update": {
          "failure": "Module could not be saved."
        }
      },
      "updateProfile": {
        "success": "Profile updated.",
        "failure": "Profile could not be updated."
      },
      "updateHangar": {
        "failure": "Hangar Settings could not be updated.",
        "success": "Hangar Settings updated."
      },
      "updatePrivacy": {
        "success": "Privacy Settings updated."
      },
      "features": {
        "updated": "Feature updated.",
        "error": "Could not update feature.",
        "actorAdded": "Actor added to feature.",
        "actorRemoved": "Actor removed from feature.",
        "groupAdded": "Group added to feature.",
        "groupRemoved": "Group removed from feature.",
        "created": "Feature created.",
        "destroyed": "Feature removed."
      },
      "rsiRequestLogs": {
        "resolved": "Request log marked as resolved.",
        "error": "Could not update request log."
      },
      "updateNotifications": {
        "success": "Notification Settings updated.",
        "failure": "Could not save your notification settings."
      },
      "pushNotifications": {
        "failure": "Push notifications could not be updated."
      },
      "updateAccount": {
        "success": "Account updated."
      },
      "oauthApplications": {
        "create": {
          "success": "OAuth application created.",
          "error": "Could not create OAuth application."
        },
        "update": {
          "success": "OAuth application updated.",
          "error": "Could not update OAuth application."
        },
        "destroy": {
          "success": "OAuth application deleted.",
          "error": "Could not delete OAuth application."
        },
        "regenerateSecret": {
          "success": "Client secret regenerated.",
          "error": "Could not regenerate client secret."
        },
        "copied": "Copied to clipboard.",
        "copyError": "Could not copy to clipboard.",
        "secretWarning": "Copy your client secret now. You won't be able to see it again."
      },
      "avatarUpload": {
        "create": {
          "success": "Avatar uploaded",
          "failure": "Could not upload Avatar"
        },
        "destroy": {
          "success": "Avatar removed",
          "failure": "Could not remove Avatar"
        }
      },
      "hangarImport": {
        "success": "Import completed",
        "partialSuccess": "Import partially completed.<br><br>Not found Ships: <br>%{missing}",
        "failure": "Import failed",
        "queued": "Import queued. You can follow it here."
      },
      "hangarExport": {
        "failure": "Export failed, Please try again later."
      },
      "vehicle": {
        "move": {
          "failure": "The order could not be saved."
        },
        "add": {
          "success": {
            "noHtml": "Your new %{model} will be delivered to your Hangar",
            "paragraph1": "Your new ",
            "paragraph2": "will be delivered to your "
          }
        },
        "addToWishlist": {
          "success": {
            "noHtml": "Your new %{model} was added to your Wishlist",
            "paragraph2": "was added to your "
          }
        },
        "resetIngame": {
          "moveToWishlist": {
            "success": "Moved all Ingame bought Ships to your Wishlist.",
            "failure": "Could not move all Ingame bought Ships to your Wishlist."
          },
          "removeAll": {
            "confirm": "Remove every ship you bought in-game from your hangar? This cannot be undone.",
            "success": "Removed all Ingame bought Ships from your Hangar.",
            "failure": "Could not remove all Ingame bought Ships from your Hangar."
          }
        }
      },
      "model": {
        "syncMatrixStarted": "Model matrix sync started. You will be notified when it completes.",
        "syncScDataStarted": "Model SC data sync started. You will be notified when it completes.",
        "importPaintsStarted": "Paint import started. You will be notified when it completes.",
        "syncShipViewsStarted": "Ship views sync started. New renders appear here once they are processed.",
        "dimensionsDrifted": "These dimensions differ from the game files."
      },
      "announcement": {
        "created": "Announcement created.",
        "updated": "Announcement updated.",
        "destroyed": "Announcement deleted.",
        "destroyFailed": "Could not delete the announcement.",
        "createFailed": "Could not create announcement.",
        "updateFailed": "Could not update announcement.",
        "testSent": "Test sent to the admin Discord channel.",
        "testFailed": "Could not send the test.",
        "published": "Announcement is on its way.",
        "publishFailed": "Could not send announcement.",
        "retryQueued": "Delivery queued again.",
        "retryFailed": "Could not retry this delivery.",
        "refreshQueued": "Counts are being refreshed.",
        "refreshFailed": "Could not refresh the counts."
      },
      "fundingGoal": {
        "created": "Funding goal created.",
        "updated": "Funding goal updated.",
        "destroyed": "Funding goal deleted.",
        "createFailed": "Could not create funding goal.",
        "updateFailed": "Could not update funding goal."
      },
      "supporterNomination": {
        "update": {
          "success": "Fleet selection updated.",
          "failure": "Could not update the fleet selection."
        },
        "change": {
          "confirm": "%{fleet} may lose the fleet features it has now. Continue?"
        }
      },
      "supporterContribution": {
        "created": "Supporter contribution created.",
        "updated": "Supporter contribution updated.",
        "destroyed": "Supporter contribution deleted.",
        "createFailed": "Could not create supporter contribution.",
        "updateFailed": "Could not update supporter contribution."
      },
      "notification": {
        "granted": "Welcome to FleetYards.net Notifications!"
      },
      "twoFactor": {
        "enable": {
          "success": "Two-factor Authentication enabled!",
          "failure": "Could not enable Two-factor Authentication."
        },
        "disable": {
          "success": "Two-factor Authentication disabled!",
          "failure": "Could not disable Two-factor Authentication."
        },
        "backupCodes": {
          "failure": "Backup Codes could not be generated."
        }
      },
      "error": {
        "usernameTaken": "Username is already taken.",
        "userNotFound": "User not found",
        "emailTaken": "Email is already taken.",
        "fleetTaken": "Fleet is already taken.",
        "colorInvalid": "Color is invalid",
        "serialTaken": "Serial is already taken.",
        "textInvalid": "%{field} is invalid",
        "fleetNameInvalid": "The %{field} field may contain alpha-numeric characters, spaces, dots, dashes and underscores",
        "vehicleSerialInvalid": "The %{field} field must look like the registration the game shows, such as L8-4261-HA",
        "hangar": {
          "accountRequired": {
            "noHtml": "You need to Sign up or Login to add Ships to your Hangar.",
            "paragraph1": "You need to ",
            "paragraph2": " to add Ships to your Hangar.",
            "paragraph3": "Get more Information "
          }
        },
        "blueprint": {
          "accountRequired": "Sign up or log in to keep track of the recipes you hold.",
          "own": "We could not update that recipe. Please try again."
        },
        "default": "<b>Something wrong happened.</b> <br>Have you tried turning it off and on again?"
      },
      "account": {
        "destroy": {
          "success": "<b>Your Account has been destroyed.</b> <br>Sad to see you go :'(",
          "failure": "We could not destroy your Account! Please try again later."
        },
        "calendarSubscription": {
          "enable": {
            "success": "Personal calendar subscription enabled.",
            "failure": "Could not enable calendar subscription."
          },
          "rotate": {
            "success": "Personal calendar link rotated. Existing subscribers will stop receiving updates until they re-subscribe.",
            "failure": "Could not rotate personal calendar link.",
            "confirm": "Rotating the link will silently invalidate any calendar app subscribed to the current URL. You'll need to re-subscribe with the new link."
          },
          "disable": {
            "success": "Personal calendar subscription disabled.",
            "failure": "Could not disable personal calendar subscription.",
            "confirm": "Disabling the subscription will kill the feed for any calendar app currently subscribed."
          }
        },
        "supporterClaimKey": {
          "copy": {
            "success": "Key copied.",
            "failure": "The key could not be copied."
          }
        }
      },
      "user": {
        "destroy": {
          "success": "User destroyed.",
          "failure": "Could not destroy user."
        }
      },
      "fleet": {
        "fidClaim": {
          "create": {
            "success": "Claim opened. The fleet that holds the ID has been told.",
            "failure": "The fleet ID could not be claimed."
          },
          "destroy": {
            "success": "Claim withdrawn.",
            "failure": "The claim could not be withdrawn."
          },
          "endNow": {
            "success": "Grace period ended.",
            "failure": "The grace period could not be ended."
          },
          "cancel": {
            "success": "Claim cancelled.",
            "failure": "The claim could not be cancelled."
          }
        },
        "create": {
          "success": "Your Fleet has been created.",
          "failure": "Fleet could not be saved."
        },
        "update": {
          "success": "Settings saved.",
          "failure": "Settings could not be saved."
        },
        "destroy": {
          "success": "Your Fleet has been destroyed.",
          "failure": "We could not destroy your Fleet."
        },
        "leave": {
          "success": "You have left the Fleet.",
          "failure": "Could not leave the Fleet."
        },
        "invites": {
          "accept": {
            "success": "Invite accepted.",
            "failure": "Could not accept Invite."
          },
          "decline": {
            "success": "Invite declined.",
            "failure": "Could not decline Invite."
          },
          "create": {
            "failure": "Could not invite User."
          }
        },
        "members": {
          "update": {
            "success": "Settings saved.",
            "failure": "Settings could not be saved."
          },
          "destroy": {
            "success": "Member removed.",
            "failure": "Member could not be removed."
          },
          "demote": {
            "success": "Member demoted.",
            "failure": "Member could not be demoted."
          },
          "promote": {
            "success": "Member promoted.",
            "failure": "Member could not be promoted."
          },
          "accept": {
            "success": "Member accepted.",
            "failure": "Member could not be accepted."
          },
          "decline": {
            "success": "Member declined.",
            "failure": "Member could not be declined."
          },
          "nickname": {
            "success": "Nickname saved.",
            "failure": "Nickname could not be saved."
          }
        },
        "roles": {
          "update": {
            "success": "Role saved.",
            "failure": "Role could not be saved."
          }
        },
        "squadrons": {
          "create": {
            "success": "Squadron created.",
            "failure": "Squadron could not be created."
          },
          "update": {
            "success": "Squadron saved.",
            "failure": "Squadron could not be saved."
          },
          "destroy": {
            "confirm": "Disband the squadron \"%{name}\"? Its members stay in the fleet.",
            "success": "Squadron disbanded.",
            "failure": "Squadron could not be disbanded."
          },
          "sort": {
            "failure": "The order could not be saved."
          },
          "ranks": {
            "update": {
              "success": "Squadron ranks saved.",
              "failure": "Squadron ranks could not be saved."
            }
          },
          "members": {
            "add": {
              "success": "%{count} members added.",
              "failure": "%{count} members could not be added."
            },
            "destroy": {
              "confirm": "Remove %{username} from the %{squadron} squadron? They stay in the fleet.",
              "success": "Member removed from the squadron.",
              "failure": "Member could not be removed."
            }
          },
          "join": {
            "success": "You joined the team.",
            "failure": "Could not join the team."
          },
          "leave": {
            "confirm": "Leave the %{squadron} squadron? You stay in the fleet.",
            "success": "You left the squadron.",
            "failure": "Could not leave the squadron."
          },
          "requests": {
            "create": {
              "success": "Request sent. The squadron's leadership will answer it.",
              "failure": "Request could not be sent."
            },
            "withdraw": {
              "success": "Request withdrawn.",
              "failure": "Request could not be withdrawn."
            },
            "blocked": {
              "member": "You are already in %{squadron}. Leave it before asking to join another squadron.",
              "requested": "You asked to join %{squadron}. Withdraw that request before asking another squadron."
            },
            "accept": {
              "success": "%{username} joined the squadron.",
              "failure": "Request could not be accepted."
            },
            "decline": {
              "success": "Request declined.",
              "failure": "Request could not be declined."
            }
          },
          "rank": {
            "success": "Rank changed.",
            "failure": "Rank could not be changed."
          }
        },
        "calendarSubscription": {
          "enable": {
            "success": "Calendar subscription enabled.",
            "failure": "Could not enable calendar subscription."
          },
          "rotate": {
            "success": "Subscription link rotated. Existing subscribers will stop receiving updates until they re-subscribe.",
            "failure": "Could not rotate subscription link.",
            "confirm": "Rotating the link will silently invalidate any calendar app subscribed to the current URL. They'll need to re-subscribe with the new link."
          },
          "disable": {
            "success": "Calendar subscription disabled.",
            "failure": "Could not disable calendar subscription.",
            "confirm": "Disabling the subscription will kill the feed for any calendar app currently subscribed."
          },
          "copy": {
            "success": "Calendar link copied. Paste it into your calendar app under \"Subscribe to calendar\" or \"Add by URL\".",
            "failure": "Could not copy calendar link."
          }
        }
      },
      "fleetInvite": {
        "used": "<b>Join request for %{fleet} send!</b><br>Once your Membership is accepted you will be notified via email",
        "failure": "Invite could not be used.",
        "confirm": "Are you sure you want to join the Fleet: \"%{fleet}\"?"
      },
      "holoViewer": {
        "modelLoader": {
          "failure": "We could not load the requested 3D model! Please try again later."
        },
        "webglNotSupported": "3D viewer is not available on this device.",
        "tooLarge": "This 3D model is %{size} MB and may be too large for this device."
      },
      "cargoGridViewer": {
        "confirmReset": "Are you sure you want to reset all ships and container settings?"
      },
      "confirm": {
        "vehicle": {
          "destroy": "Are you sure you want to remove this Ship from you Hangar?"
        },
        "buyback": {
          "destroy": "Remove this pledge from your buy-back list? Use this after buying it back on RSI. The next sync brings it back if it is still listed there."
        },
        "hangarGroup": {
          "destroy": "Are you sure you want to remove this Group from you Hangar?"
        },
        "hangar": {
          "import": "Imported ships will be added to your Hangar without matching to existing Ships.<br><br>Supported Formats are: Fleetyards Export or HangarXplor.<br><br>Do you want to continue?",
          "destroySelected": "Are you sure you want to remove all Selected Ships from you Hangar? This Action can't be reverted.",
          "destroyAll": "Are you sure you want to remove all Ships from you Hangar? This Action can't be reverted."
        },
        "wishlist": {
          "destroyAll": "Are you sure you want to remove all Ships from you Wishlist? This Action can't be reverted."
        },
        "account": {
          "destroy": "Are you sure you want to destroy your Account? This Action can't be reverted.",
          "destroyWithFleets": "You are the admin of the following Fleet(s): %{fleets}. Deleting your account will also destroy these Fleets and remove all their members. This Action can't be reverted. Continue?"
        },
        "itemPrice": {
          "destroy": "Are you sure you want to destroy this Item Price? This Action can't be reverted."
        },
        "fleet": {
          "leave": "Are you sure you want to leave the Fleet? This Action can't be reverted.",
          "destroy": "Are you sure you want to destroy your Fleet? This Action can't be reverted.",
          "members": {
            "destroy": "Are you sure you want to remove this Member?",
            "remove": "Are you sure you want to remove this member from the fleet?"
          },
          "invites": {
            "decline": "Are you sure you want to decline this Invite? This Action can't be reverted."
          }
        },
        "oauthApplication": {
          "destroy": "Are you sure you want to delete this OAuth application? This action can't be reverted.",
          "regenerateSecret": "Are you sure you want to regenerate the client secret? Existing integrations will stop working."
        },
        "twoFactor": {
          "generateBackupCodes": "Are you sure you want to regenerate your Two-factor Backup Codes?"
        },
        "user": {
          "loginAs": "Are you sure you want to login as this user?",
          "resendConfirmation": "Are you sure you want to resend the confirmation email for this user?",
          "sendPasswordReset": "Are you sure you want to send a password reset email for this user?",
          "destroy": "Are you sure you want to delete this user? This action can't be reverted.",
          "destroyWithFleets": "This user is the admin of the following Fleet(s): %{fleets}. Deleting the user will also destroy these Fleets and remove all their members. This action can't be reverted. Continue?"
        },
        "model": {
          "destroy": "Are you sure you want to delete this model? This action can't be reverted.",
          "sync": "Are you sure you want to sync this model from RSI?",
          "syncMatrix": "Are you sure you want to sync the ship matrix data for this model?",
          "syncScData": "Are you sure you want to sync the SC data for this model?",
          "importPaints": "Are you sure you want to import this model's paints from the hangar data? A paint the source names for a whole series is imported for every model of that series.",
          "syncShipViews": "Are you sure you want to sync this model's ship views from the render bucket? New and changed renders are attached, and removed ones come back. A view uploaded by hand over an imported render is kept.",
          "exchangeStoreImage": "Are you sure you want to replace the store image with the RSI image?",
          "reloadMatrix": "Are you sure you want to reload the models matrix? This will enqueue background jobs.",
          "reloadScData": "Are you sure you want to reload SC data? This will enqueue background jobs.",
          "reloadPaints": "Are you sure you want to reload paints? This will enqueue background jobs.",
          "reloadModules": "Are you sure you want to reload modules? This will enqueue background jobs.",
          "reloadLoaners": "Are you sure you want to reload loaners? This will enqueue background jobs."
        },
        "manufacturer": {
          "destroy": "Are you sure you want to delete this manufacturer? This action can't be reverted."
        },
        "announcement": {
          "publish": "Send this announcement to %{channels}? It cannot be recalled.",
          "destroy": "Are you sure you want to delete this announcement? This action can't be reverted."
        },
        "fundingGoal": {
          "destroy": "Are you sure you want to delete this funding goal? This action can't be reverted."
        },
        "supporterContribution": {
          "destroy": "Are you sure you want to delete this supporter contribution? This action can't be reverted."
        },
        "modelPosition": {
          "destroy": "Are you sure you want to delete this position? This action can't be reverted."
        },
        "modelLoaner": {
          "destroy": "Are you sure you want to delete this loaner? This action can't be reverted."
        },
        "modelSnubCraft": {
          "destroy": "Are you sure you want to delete this snub craft? This action can't be reverted."
        },
        "modelPaint": {
          "destroy": "Are you sure you want to delete this paint? This action can't be reverted."
        },
        "video": {
          "destroy": "Are you sure you want to delete this video? This action can't be reverted."
        },
        "modelModule": {
          "destroy": "Are you sure you want to delete this module? This action can't be reverted.",
          "unlink": "Are you sure you want to unlink this module from the model? The module will still exist but won't be associated with this model."
        },
        "modelUpgrade": {
          "destroy": "Are you sure you want to delete this upgrade? This action can't be reverted.",
          "unlink": "Are you sure you want to unlink this upgrade from the model? The upgrade will still exist but won't be associated with this model."
        },
        "modelModulePackage": {
          "destroy": "Are you sure you want to delete this module package? This action can't be reverted."
        },
        "dockCapacity": {
          "destroy": "Are you sure you want to delete this capacity entry? This action can't be reverted."
        },
        "dock": {
          "destroy": "Are you sure you want to delete this dock? This action can't be reverted."
        },
        "component": {
          "destroy": "Are you sure you want to delete this component? This action can't be reverted."
        },
        "adminFleet": {
          "destroy": "Are you sure you want to delete this fleet? This action can't be reverted."
        },
        "adminNotifications": {
          "destroyAll": "Are you sure you want to delete all notifications? This action can't be reverted.",
          "destroySelected": {
            "one": "Are you sure you want to delete the selected notification? This action can't be reverted.",
            "other": "Are you sure you want to delete the %{count} selected notifications? This action can't be reverted."
          }
        },
        "adminFleetFidClaim": {
          "endNow": "End the grace period now? The holder is renamed and the claimant gets the fleet ID at once.",
          "cancel": "Cancel this claim? Both fleets are told, and the holder keeps the fleet ID."
        },
        "fleetFidClaim": {
          "create": "Claim the fleet ID %{fid}? The fleet that holds it is told now, and it loses the ID in 14 days unless it proves the RSI organisation itself."
        },
        "adminDestroyedFleet": {
          "restore": "Are you sure you want to restore this fleet?",
          "restorePurged": "Are you sure you want to restore this purged fleet? Restoring is best-effort: roles, images, invite links and fleet vehicles are not restored."
        },
        "adminUser": {
          "destroy": "Are you sure you want to delete this admin user? This action can't be reverted."
        },
        "image": {
          "destroy": "Are you sure you want to delete this image? This action can't be reverted."
        },
        "adminVehicle": {
          "destroy": "Are you sure you want to delete this vehicle? This action can't be reverted."
        },
        "commodity": {
          "destroy": "Are you sure you want to delete this commodity? This action can't be reverted."
        },
        "equipment": {
          "destroy": "Are you sure you want to delete this equipment? This action can't be reverted."
        },
        "notifications": {
          "destroyAll": "Are you sure you want to delete all notifications? This action can't be reverted.",
          "destroySelected": {
            "one": "Are you sure you want to delete the selected notification? This action can't be reverted.",
            "other": "Are you sure you want to delete the %{count} selected notifications? This action can't be reverted."
          }
        },
        "unlistedModel": {
          "createModel": "Create a ship from %{name}? The next sc_data load fills in its mechanics."
        },
        "import": {
          "cleanup": "Mark this import as failed? Do this only if the job is really gone — a run that is still working will error out when it finishes.",
          "cleanupSelected": "Mark the selected imports as failed? Only the ones still running are affected, and a run that is genuinely still working will error out when it finishes.",
          "cancel": "Stop this import? Ships it has already added are kept."
        },
        "hardpoint": {
          "destroy": "Are you sure you want to delete this hardpoint? This action can't be reverted."
        },
        "fleets": {
          "contractItem": {
            "destroy": "Remove these goods from the contract?"
          }
        },
        "vehicleLog": {
          "destroy": "Do you really want to remove this log entry?"
        }
      },
      "oauthAuthorize": {
        "loading": "Loading...",
        "loadError": "Failed to load authorization details.",
        "authorizeError": "Authorization failed.",
        "denyError": "Authorization denial failed."
      },
      "oauth": {
        "disconnect": {
          "success": "Provider disconnected successfully.",
          "failure": "Could not disconnect provider. Please try again."
        }
      },
      "confirmAccess": {
        "failure": "Access could not be confirmed. Please check your password and try again."
      },
      "setEmail": {
        "success": "A confirmation email has been sent to your new email address. Please check your inbox.",
        "failure": "Could not update your email address. Please try again."
      },
      "confirmAccessEmail": {
        "sent": "A confirmation code has been sent to your email.",
        "failure": "Could not send confirmation email. Please try again."
      },
      "confirmAccessCode": {
        "failure": "The confirmation code is invalid or has expired."
      },
      "import": {
        "started": "%{type} import started...",
        "finished": "%{type} import completed successfully.",
        "failed": "%{type} import failed: %{info}"
      },
      "buybackSync": {
        "started": "Syncing your buy-back pledges...",
        "success": "Your buy-back pledges have been synced.",
        "failure": "Your buy-back pledges could not be synced.",
        "detailsSuccess": "Prices and insurance of your buy-back pledges are up to date."
      },
      "syncExtension": {
        "started": "Syncing your Hangar...",
        "success": "Your Hangar has been synced.",
        "failure": "Your Hangar could not be synced.",
        "cancelled": "The hangar sync was cancelled.",
        "pageNotRecognised": "RSI's page looks different from what FleetYards expects, so the sync stopped without changing anything.",
        "nothingToSync": "FleetYards found no ships, paints or components in your RSI hangar, so nothing was changed.",
        "onlySkippedItems": "Your RSI hangar only holds paints or hangar flair, which this sync is set to leave out, so nothing was changed.",
        "nothingReadable": "Some items in your RSI hangar could not be read and FleetYards found nothing else, so nothing was changed.",
        "notLoggedIn": "You need to be logged in on <a href=\"https://robertsspaceindustries.com\" target=\"_blank\">https://robertsspaceindustries.com</a> to sync your Hangar."
      },
      "admin": {
        "form": {
          "created": "Created.",
          "updated": "Changes saved."
        },
        "importLoaders": {
          "started": "%{name} started.",
          "failed": "%{name} could not be started."
        },
        "supporterContributions": {
          "patreonSyncStarted": "Patreon sync started. Refresh in a minute to see imported supporters."
        },
        "imports": {
          "cleaned": "Import marked as failed",
          "cleanedUp": {
            "one": "%{count} import marked as failed",
            "other": "%{count} imports marked as failed"
          },
          "noneRunning": "Nothing in the selection was still running",
          "cleanupError": "The import could not be cleaned up"
        }
      },
      "logistics": {
        "request": {
          "create": {
            "success": "Logistics request created.",
            "failure": "Could not create logistics request."
          }
        },
        "inventory": {
          "create": {
            "success": "Inventory created.",
            "failure": "Could not create inventory."
          },
          "update": {
            "success": "Inventory updated.",
            "failure": "Could not update inventory."
          },
          "destroy": {
            "success": "Inventory deleted.",
            "failure": "Could not delete inventory."
          }
        },
        "inventoryItem": {
          "create": {
            "success": "Item added to inventory.",
            "failure": "Could not add item to inventory."
          },
          "deposit": {
            "success": "Deposit recorded.",
            "failure": "Could not record deposit."
          },
          "withdrawal": {
            "success": "Withdrawal recorded.",
            "failure": "Could not record withdrawal. Check available stock."
          },
          "destroy": {
            "success": "Entry deleted.",
            "failure": "Could not delete entry.",
            "confirm": "Delete this entry? The stock it added or removed is corrected accordingly."
          }
        },
        "comment": {
          "create": {
            "success": "Comment added.",
            "failure": "Could not add comment."
          }
        },
        "csvImport": {
          "success": "%{count} items imported successfully.",
          "failure": "Could not import CSV file."
        },
        "stockItem": {
          "update": {
            "success": "Item updated.",
            "failure": "Could not update item."
          },
          "destroy": {
            "success": "Item deleted.",
            "failure": "Could not delete item.",
            "confirm": "Delete this item and all %{count} of its entries? This cannot be undone."
          }
        },
        "vehicleInventory": {
          "clear": {
            "confirm": "Clear this ship's cargo? Every entry is deleted.",
            "success": "Cargo cleared.",
            "failure": "Could not clear the cargo."
          }
        },
        "transfer": {
          "needsAnswer": "They have to accept this before it arrives. The stock leaves your inventory now and comes back if they decline.",
          "create": {
            "failure": "Could not send the transfer"
          },
          "resolve": {
            "failure": "Could not update the transfer"
          },
          "reportHint": "Reporting this declines it and sends the goods back, and stops this sender reaching you again."
        }
      },
      "adminNotifications": {
        "read": "Notification marked as read",
        "unread": "Notification marked as unread",
        "archived": "Notification archived",
        "unarchived": "Notification moved back to the inbox",
        "readAll": "All notifications marked as read",
        "destroyed": "Notification deleted",
        "destroyedAll": "All notifications deleted",
        "error": "Something went wrong",
        "bulk": {
          "read": {
            "one": "%{count} notification marked as read",
            "other": "%{count} notifications marked as read"
          },
          "unread": {
            "one": "%{count} notification marked as unread",
            "other": "%{count} notifications marked as unread"
          },
          "archived": {
            "one": "%{count} notification archived",
            "other": "%{count} notifications archived"
          },
          "unarchived": {
            "one": "%{count} notification moved back to the inbox",
            "other": "%{count} notifications moved back to the inbox"
          },
          "destroyed": {
            "one": "%{count} notification deleted",
            "other": "%{count} notifications deleted"
          }
        }
      },
      "fleets": {
        "notifications": {
          "update": {
            "success": "Notification settings saved.",
            "failure": "Could not save notification settings."
          }
        },
        "mission": {
          "publish": {
            "success": "Mission published — the fleet can see it now.",
            "failure": "Could not publish mission."
          },
          "create": {
            "success": "Mission created.",
            "failure": "Could not create mission."
          },
          "update": {
            "success": "Mission updated.",
            "failure": "Could not update mission."
          },
          "archive": {
            "success": "Mission archived.",
            "failure": "Could not archive mission."
          },
          "unarchive": {
            "success": "Mission restored.",
            "failure": "Could not restore mission."
          },
          "destroy": {
            "success": "Mission deleted.",
            "failure": "Could not delete mission.",
            "confirm": "This will permanently delete the mission and all its teams, ships, and slots. This action cannot be undone."
          }
        },
        "missionTeam": {
          "create": {
            "success": "Team added.",
            "failure": "Could not add team."
          },
          "update": {
            "success": "Team updated.",
            "failure": "Could not update team."
          },
          "destroy": {
            "success": "Team removed.",
            "failure": "Could not remove team."
          }
        },
        "missionShip": {
          "create": {
            "success": "Ship added.",
            "failure": "Could not add ship."
          },
          "update": {
            "success": "Ship updated.",
            "failure": "Could not update ship."
          },
          "destroy": {
            "success": "Ship removed.",
            "failure": "Could not remove ship."
          },
          "duplicate": {
            "success": "Ship duplicated.",
            "failure": "Could not duplicate the ship."
          }
        },
        "missionSlot": {
          "create": {
            "success": "Slot added.",
            "failure": "Could not add slot."
          },
          "update": {
            "success": "Slot updated.",
            "failure": "Could not update slot."
          },
          "destroy": {
            "success": "Slot removed.",
            "failure": "Could not remove slot."
          }
        },
        "event": {
          "create": {
            "success": "Event created.",
            "failure": "Could not create event."
          },
          "update": {
            "success": "Event updated.",
            "failure": "Could not update event."
          },
          "archive": {
            "success": "Event archived.",
            "failure": "Could not archive event.",
            "confirm": "Archive this event? Members will no longer see it in the upcoming list."
          },
          "unarchive": {
            "success": "Event restored from archive.",
            "failure": "Could not restore event."
          },
          "syncToDiscord": {
            "success": "Event pushed to Discord.",
            "failure": "Could not push event to Discord."
          },
          "destroy": {
            "success": "Event deleted.",
            "failure": "Could not delete event.",
            "confirm": "This will permanently delete the event. This action cannot be undone."
          },
          "publish": {
            "success": "Event published — sign-ups are now open.",
            "failure": "Could not publish event."
          },
          "lockSignups": {
            "success": "Sign-ups locked.",
            "failure": "Could not lock sign-ups."
          },
          "unlockSignups": {
            "success": "Sign-ups reopened.",
            "failure": "Could not reopen sign-ups."
          },
          "start": {
            "success": "Event started.",
            "failure": "Could not start event."
          },
          "complete": {
            "success": "Event marked as completed.",
            "failure": "Could not complete event."
          },
          "cancel": {
            "success": "Event cancelled.",
            "failure": "Could not cancel event.",
            "confirm": "Cancel this event? Participants will be notified."
          }
        },
        "eventSignup": {
          "create": {
            "success": "You're signed up.",
            "failure": "Could not sign up."
          },
          "update": {
            "success": "Signup updated.",
            "failure": "Could not update signup."
          },
          "withdraw": {
            "success": "You withdrew from the event.",
            "failure": "Could not withdraw.",
            "confirm": "Withdraw from this event?"
          },
          "kick": {
            "success": "Signup removed.",
            "failure": "Could not remove signup.",
            "confirm": "Remove this member's signup?"
          }
        },
        "eventAdmin": {
          "create": {
            "success": "Role granted.",
            "failure": "Could not grant role."
          },
          "destroy": {
            "success": "Role revoked.",
            "failure": "Could not revoke role.",
            "confirm": "Revoke %{username}'s role for this event?"
          }
        },
        "eventTeam": {
          "create": {
            "success": "Team added.",
            "failure": "Could not add team."
          },
          "update": {
            "success": "Team updated.",
            "failure": "Could not update team."
          },
          "destroy": {
            "success": "Team removed.",
            "failure": "Could not remove team.",
            "confirm": "Remove this team and all its ships and slots?"
          }
        },
        "eventShip": {
          "create": {
            "success": "Ship added.",
            "failure": "Could not add ship."
          },
          "update": {
            "success": "Ship updated.",
            "failure": "Could not update ship."
          },
          "destroy": {
            "success": "Ship removed.",
            "failure": "Could not remove ship.",
            "confirm": "Remove this ship and its slots?"
          }
        },
        "eventSlot": {
          "create": {
            "success": "Slot added.",
            "failure": "Could not add slot."
          },
          "update": {
            "success": "Slot updated.",
            "failure": "Could not update slot."
          },
          "destroy": {
            "success": "Slot removed.",
            "failure": "Could not remove slot."
          }
        },
        "contract": {
          "create": {
            "success": "Contract created",
            "failure": "Contract could not be created"
          },
          "update": {
            "success": "Contract saved",
            "failure": "Contract could not be saved"
          },
          "item": {
            "create": {
              "failure": "Goods could not be added"
            },
            "destroy": {
              "failure": "Goods could not be removed"
            },
            "update": {
              "failure": "The goods could not be changed"
            }
          }
        },
        "contracts": {
          "deliverHint": "Send the goods from one of your own inventories and pick this contract, so the delivery counts towards it.",
          "expiredHint": "This contract has expired and takes no new deliveries. Deliveries already on their way still count once they are accepted."
        }
      },
      "notifications": {
        "read": "Notification marked as read",
        "unread": "Notification marked as unread",
        "archived": "Notification archived",
        "unarchived": "Notification moved back to the inbox",
        "readAll": "All notifications marked as read",
        "destroyed": "Notification deleted",
        "destroyedAll": "All notifications deleted",
        "actionDone": "Done",
        "actionFailed": "That did not work - the notification may be out of date",
        "error": "Something went wrong",
        "bulk": {
          "read": {
            "one": "%{count} notification marked as read",
            "other": "%{count} notifications marked as read"
          },
          "unread": {
            "one": "%{count} notification marked as unread",
            "other": "%{count} notifications marked as unread"
          },
          "archived": {
            "one": "%{count} notification archived",
            "other": "%{count} notifications archived"
          },
          "unarchived": {
            "one": "%{count} notification moved back to the inbox",
            "other": "%{count} notifications moved back to the inbox"
          },
          "destroyed": {
            "one": "%{count} notification deleted",
            "other": "%{count} notifications deleted"
          }
        }
      },
      "imports": {
        "cancel": {
          "success": "Import cancelled",
          "error": "Could not cancel this import"
        }
      },
      "payouts": {
        "participantAddedUser": "%{name} added with their FleetYards account",
        "participantAddedGuest": "%{name} added as a guest",
        "invalidAmount": "Enter an amount, e.g. 1,500.50",
        "currencyUpdated": "Currency updated",
        "tourArchived": "Tour archived",
        "tourUnarchived": "Tour restored",
        "tourDeleted": "Tour deleted",
        "deleteTourConfirm": "Delete this tour? This cannot be undone.",
        "archiveTourConfirm": "Archive this tour? It leaves the list but keeps its ledger.",
        "entryCreated": "Entry recorded",
        "entryUpdated": "Entry updated",
        "destroyEntryConfirm": "Delete this entry? This cannot be undone.",
        "entryDestroyed": "Entry removed",
        "participantAdded": "Participant added",
        "participantRemoved": "Participant removed",
        "participantHasEntries": "Remove their entries first",
        "settled": "Payouts calculated",
        "reopened": "Ledger reopened",
        "tourCreated": "Tour created",
        "tourCreateFailure": "Tour could not be created.",
        "tourJoined": "You joined the tour",
        "settleConfirm": "Calculate the payouts and lock the ledger? Entries can no longer be changed until it is reopened.",
        "reopenConfirm": "Reopen the ledger? The current payout list will be discarded.",
        "participantNeedsName": "Enter a username or a name",
        "weightUpdated": "Share updated",
        "joinRequested": "Your request was sent",
        "joinRequestWithdrawn": "Request withdrawn",
        "joinRequestApproved": "Request approved",
        "joinRequestDeclined": "Request declined",
        "expenseApproved": "Expense approved",
        "expenseDeclined": "Expense declined",
        "pendingReview": "%{count} expense(s) waiting for review"
      },
      "dockAddition": {
        "create": {
          "failure": "Could not name that ship."
        },
        "destroy": {
          "failure": "Could not remove that ship."
        }
      },
      "dockCapacity": {
        "create": {
          "failure": "Could not create the capacity entry."
        },
        "update": {
          "failure": "Could not save the capacity entry."
        },
        "destroy": {
          "failure": "Could not delete the capacity entry."
        }
      },
      "dock": {
        "create": {
          "failure": "Could not create the dock."
        },
        "update": {
          "failure": "Could not save the dock."
        },
        "destroy": {
          "failure": "Could not delete the dock."
        }
      },
      "relationships": {
        "user": {
          "addHint": "Enter the username of the person you want to add. They will be asked to accept."
        },
        "fleet": {
          "addHint": "Enter the slug of the fleet you want to ally with. Its admins will be asked to accept."
        }
      },
      "friends": {
        "request": {
          "success": "Request sent",
          "failure": "Could not send the request"
        },
        "accept": {
          "success": "Request accepted",
          "failure": "Could not accept the request"
        },
        "decline": {
          "success": "Request declined",
          "failure": "Could not decline the request"
        },
        "ignore": {
          "success": "Request ignored",
          "failure": "Could not ignore the request"
        },
        "remove": {
          "success": "Removed",
          "failure": "Could not remove it"
        }
      },
      "fleetAllies": {
        "request": {
          "success": "Request sent",
          "failure": "Could not send the request"
        },
        "accept": {
          "success": "Request accepted",
          "failure": "Could not accept the request"
        },
        "decline": {
          "success": "Request declined",
          "failure": "Could not decline the request"
        },
        "ignore": {
          "success": "Request ignored",
          "failure": "Could not ignore the request"
        },
        "remove": {
          "success": "Removed",
          "failure": "Could not remove it"
        }
      },
      "vehiclePlaque": {
        "removeConfirm": "Remove this ship's dedication plaque?",
        "downloadFailure": "The plaque could not be saved as an image",
        "failure": "The plaque could not be saved"
      },
      "vehicleOverview": {
        "image": {
          "success": "Picture saved",
          "failure": "The picture could not be saved"
        },
        "paint": {
          "failure": "The paint could not be applied"
        },
        "setting": {
          "failure": "The setting could not be saved"
        },
        "location": {
          "failure": "The location could not be saved"
        }
      },
      "vehicleLog": {
        "create": {
          "success": "Log entry added",
          "failure": "The log entry could not be added"
        },
        "update": {
          "success": "Log entry saved",
          "failure": "The log entry could not be saved"
        },
        "destroy": {
          "failure": "The log entry could not be removed"
        },
        "defaultUpdate": {
          "failure": "The setting could not be saved"
        }
      },
      "vehicleLoadout": {
        "failure": "The loadout could not be saved."
      }
    }
  }
}
